<div id="profile-dropdown" data-testid="profile-dropdown-container" [ngClass]="{'dropdown-visible': dropdownVisible()}">
  @if (!infoSubMenuVisible()) {
    @if (!isAuthorized()) {
      <button type="button" class="ev-plain-button dropdown-el" data-testid="profile-dropdown-login-btn" (click)="login()">
        <img alt="login" class="dropdown-el-icon login-icon" [src]="loginIconPath()" />
        <span class="dropdown-el-text">{{ languageService.languageJSON.Global_Login }}</span>
      </button>
    }
    @if (isAuthorized()) {
      <button type="button" class="ev-plain-button dropdown-el" data-testid="profile-dropdown-edit-account-btn" (click)="openAccountDialog()">
        <img alt="edit" class="dropdown-el-icon edit-icon" [src]="editIconPath()" />
        <span class="dropdown-el-text">{{ languageService.languageJSON.Global_EditAccount }}</span>
      </button>
    }
    <button type="button" class="ev-plain-button dropdown-el" data-testid="profile-dropdown-subscriptions-btn" (click)="openSubscriptionsDialog()">
      <img alt="subscription" class="dropdown-el-icon subscription-icon"
        [src]="subscriptionsIconPath()" />
      <span class="dropdown-el-text">{{ languageService.languageJSON.Global_Subscriptions }}</span>
    </button>
    @if (isAuthorized()) {
      <button type="button" class="ev-plain-button dropdown-el" data-testid="profile-dropdown-history-btn" [ngClass]="{'inactive': loadingMap}" (click)="openHistoryDialog();">
        <img alt="history" class="dropdown-el-icon history-icon" [src]="historyIconPath()" />
        <span class="dropdown-el-text">{{ languageService.languageJSON.Global_History }}</span>
      </button>
    }
    <button type="button" class="ev-plain-button dropdown-el" data-testid="profile-dropdown-settings-btn" (click)="openSettings()">
      <img alt="settings" class="dropdown-el-icon settings-icon" [src]="settingsIconPath()" />
      <span class="dropdown-el-text">{{ languageService.languageJSON.Global_Settings }}</span>
    </button>
    <button type="button" class="ev-plain-button dropdown-el info-row" data-testid="profile-dropdown-info-btn" (click)="toggleInfoSubMenu()">
      <img alt="info" class="dropdown-el-icon info-icon" [src]="infoIconPath()" />
      <span class="dropdown-el-text">{{ languageService.languageJSON.Global_Info }}</span>
      <img alt="open" class="dropdown-el-arrow" [src]="openArrowIconPath()" />
    </button>
    @if (isAuthorized()) {
      <button type="button" class="ev-plain-button dropdown-el" data-testid="profile-dropdown-logout-btn" (click)="logout()">
        <img alt="logout" class="dropdown-el-icon logout-icon" [src]="logoutIconPath()" />
        <span class="dropdown-el-text">{{ languageService.languageJSON.Global_Logout }}</span>
      </button>
    }
  }
  @if (infoSubMenuVisible()) {
    <button type="button" class="ev-plain-button info-submenu-header" data-testid="profile-dropdown-info-back-btn" (click)="closeInfoSubMenu()">
      <img alt="info" class="info-submenu-back" [src]="backMenuIconPath()" />
      <span class="info-submenu-title">{{ languageService.languageJSON.Global_Info }}</span>
    </button>
    <button type="button" class="ev-plain-button dropdown-el" data-testid="profile-dropdown-info-welcome-btn" (click)="openInfoTab('welcome')">
      <img alt="welcome" class="dropdown-el-icon ev-logo" [src]="welcomeIconPath()" />
      <span class="dropdown-el-text">{{ languageService.languageJSON.TabbedInfoDialog_Welcome }}</span>
    </button>
    <button type="button" class="ev-plain-button dropdown-el" data-testid="profile-dropdown-info-feedback-btn" (click)="openInfoTab('feedback')">
      <img alt="feedback" class="dropdown-el-icon" [src]="feedbackIconPath()" />
      <span class="dropdown-el-text">{{ languageService.languageJSON.TabbedInfoDialog_Feedback }}</span>
    </button>
    <button type="button" class="ev-plain-button dropdown-el" data-testid="profile-dropdown-info-tutorial-btn" (click)="startTutorial()"
      [class.inactive]="!tutorialService.canStart()">
      <img alt="tutorial" class="dropdown-el-icon" [src]="tutorialIconPath()" />
      <span class="dropdown-el-text">{{ languageService.languageJSON.TabbedInfoDialog_Tutorial }}</span>
    </button>
    <button type="button" class="ev-plain-button dropdown-el" data-testid="profile-dropdown-info-privacy-btn" (click)="openInfoTab('privacy')">
      <img alt="privacy policy" class="dropdown-el-icon" [src]="privacyPolicyIconPath()" />
      <span class="dropdown-el-text">{{ languageService.languageJSON.TabbedInfoDialog_PrivacyPolicy }}</span>
    </button>
    <button type="button" class="ev-plain-button dropdown-el" data-testid="profile-dropdown-info-legal-btn" (click)="openInfoTab('legal')">
      <img alt="legal" class="dropdown-el-icon" [src]="legalInfoIconPath()" />
      <span class="dropdown-el-text">{{ languageService.languageJSON.TabbedInfoDialog_Legal }}</span>
    </button>
  }
</div>